import { aluElevation } from '../../utils/aluElevation';

const BOX_H = 180;

export default function AluElevationPreview({ form, showDims = false }) {
  let svg = aluElevation({ ...form, showDims });
  if (svg) svg = svg.replace('<svg ', '<svg height="160" ');
  return (
    <div style={{ background:'var(--bg-3)', border:'1px solid var(--border)',
                  borderRadius:8, padding:12, marginBottom:16 }}>
      <div style={{ fontWeight:600, fontSize:13, marginBottom:8 }}>Elevation</div>
      <div style={{ height:BOX_H, display:'flex', alignItems:'center', justifyContent:'center' }}>
        {svg ? (
          <div dangerouslySetInnerHTML={{ __html: svg }} />
        ) : (
          <div className="form-hint" style={{ textAlign:'center' }}>
            {form.product_type
              ? `Elevation for "${form.product_type}" coming soon...`
              : 'Select Product Type and dimensions to see the elevation.'}
          </div>
        )}
      </div>
    </div>
  );
}